import gql from 'graphql-tag'

export const GET_CATEGORY = gql`
  query VehicleCategories($filter: GetVehicleCategoriesInput) {
    vehicleCategories(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleCategories {
        data {
          companyId
          category
          hasRelation
          vehicleType {
            icon
            category
            type
            model
            manufacturer
          }
          icon
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_CATEGORY_BY_ID = gql`
  query VehicleCategory($filter: GetVehicleCategoryInput!) {
    vehicleCategory(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleCategory {
        companyId
        category
        hasRelation
        vehicleType {
          type
          manufacturer
          model
          category
          icon
        }
        icon
      }
    }
  }
`

export const CATEGORY_MUTATION_CREATE = gql`
  mutation CreateVehicleCategory($input: CreateVehicleCategoryInput!) {
    createVehicleCategory(input: $input) {
      isSuccessful
      message
      vehicleCategory {
        companyId
        category
        icon
      }
    }
  }
`

export const CATEGORY_MUTATION_DELETE = gql`
  mutation DeleteVehicleCategory($input: DeleteVehicleCategoryInput!) {
    deleteVehicleCategory(input: $input) {
      isSuccessful
      message
      vehicleCategory {
        companyId
        category
        icon
      }
    }
  }
`

export const CATEGORY_MUTATION_UPDATE = gql`
  mutation UpdateVehicleCategory($input: UpdateVehicleCategoryInput!) {
    updateVehicleCategory(input: $input) {
      isSuccessful
      message
      vehicleCategory {
        companyId
        category
      }
    }
  }
`
